import Typography from "@mui/material/Typography";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack } from "@mui/material";
import Button from "@/Layouts/components/Buttons/Button";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

interface IConfirmationModalProps {
	modalState: boolean;
	handleConfirmModalState: (state: boolean) => void;
	handleDeleteUnusedQueues: () => void;
}
export default function ConfirmationModal(props: Readonly<IConfirmationModalProps>) {
	const { modalState, handleConfirmModalState, handleDeleteUnusedQueues } = props;

	return (
		<Dialog
			classes={{
				paper: "!rounded-lg !shadow-md",
			}}
			open={modalState}
			onClose={() => handleConfirmModalState(false)}
		>
			<DialogTitle>
				<Typography className={"!font-monserrat !text-xl text-gray-text"}>Delete Confirmation</Typography>
				<IconButton
					className="!absolute !right-1 !top-1 !text-gray-500"
					aria-label="close"
					onClick={() => handleConfirmModalState(false)}
				>
					<CloseRoundedIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent className="max-w-[500px] min-w-[500px]">
				<Typography className="!font-sans text-gray-text !text-sm">
					You will Delete all unused Queues and their Overflow Queues as well, this action cannot be undone. Are you sure you want
					to continue?
				</Typography>
			</DialogContent>
			<DialogActions>
				<Stack mx={2} mb={2} direction={"row"} justifyContent={"flex-end"} gap={2}>
					<Button
						onClick={() => handleConfirmModalState(false)}
						variant={"contained"}
						text="Cancel"
						classes="!bg-gray-blue !rounded-md !text-sm !capitalize !font-sans !shadow-none !py-[5px]"
					/>
					<Button
						onClick={handleDeleteUnusedQueues}
						variant={"contained"}
						text="Delete"
						classes="!bg-primary !rounded-md !text-sm !capitalize !font-sans !shadow-none !py-[5px]"
					/>
				</Stack>
			</DialogActions>
		</Dialog>
	);
}
